
import App from './components/app';
import sAction from 'sAction';
import * as customFunctions from './action/exportConfig';
import * as c from '../../views/portal/_custom/exportConfig';

const customArrName = Object.keys(c);
const customArr = customArrName.map((k) => c[k]);
customArr.forEach(function(f, k) {
    sAction.customClassPole[customArrName[k]] = f;
});

sAction.addFunctions(customFunctions);
sAction.appComponent = App;
